import { render, staticRenderFns } from "./CommentVideoRecorder.vue?vue&type=template&id=0929582a&scoped=true"
import script from "./CommentVideoRecorder.vue?vue&type=script&lang=ts"
export * from "./CommentVideoRecorder.vue?vue&type=script&lang=ts"
import style0 from "./CommentVideoRecorder.vue?vue&type=style&index=0&id=0929582a&prod&lang=scss"
import style1 from "./CommentVideoRecorder.vue?vue&type=style&index=1&id=0929582a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0929582a",
  null
  
)

export default component.exports